module.exports = __webpack_public_path__ + "media/images/icon_introduction_white-c3029508c822abbb024690f7a895fc9f.png";